import React from "react";
import styled from "styled-components";

import { Image } from "antd";

export default function TableImage({ data }) {
  const [visible, setVisible] = React.useState(false);

  return (
    <ImageContainer>
      <Image
        preview={{ visible: false }}
        width={64}
        height={64}
        fallback="/images/fallback.svg"
        src={data?.length ? data[0] : "/photo-1503185912284-5271ff81b9a8.webp"}
        onClick={() => setVisible(true)}
      />
      {data?.length ? (
        <div style={{ display: "none" }}>
          <Image.PreviewGroup
            preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
          >
            {data?.map((item, key) => (
              <Image src={item} key={key} />
            ))}
          </Image.PreviewGroup>
        </div>
      ) : null}
    </ImageContainer>
  );
}
const ImageContainer = styled.div`
  width: 100%;
  padding: 16px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-bottom: 6px;
  & img {
    border-radius: 4px !important;
  }
`;
